import { AppState } from '../../types';

export const selectUserPermissionsList = (state: AppState) => state.userPermissions.list;

export const selectUserPermissionsListByUser = (state: AppState) => state.userPermissions.listByUser;

export const selectUserPermissions = (state: AppState) => state.userPermissions.selected;

export const selectDefaultOptions = (state: AppState) => state.userPermissions.defaultOptions;
